import AxiosClient from '../../../../functional/Axios/AxiosClient';

export const reviewsRootApi = {
  reviewsGet: ({ query }) => AxiosClient.get(`/root/reviews?${query}`),
};
